<!-- Page Header -->
<div class="page-header">
  <div class="page-header-left">
    <div class="page-header-icon" [ngClass]="tipoSelecionado === 'ENTRADA' ? 'icon-entrada' : 'icon-saida'">
      <i class="pi pi-dollar"></i>
    </div>
    <div class="page-header-text">
      <h1>{{ texts.titulo }}</h1>
      <p>{{ texts.subtitulo }}</p>
    </div>
  </div>
</div>

<!-- Toggle Receber/Pagar -->
<div class="toggle-container">
  <p-selectButton
    [options]="tipoOptions"
    [(ngModel)]="tipoSelecionado"
    optionLabel="label"
    optionValue="value"
    (onChange)="onTipoChange()"
    styleClass="toggle-tipo">
  </p-selectButton>
</div>

<!-- Filtros -->
<div class="filtros-section">
  <!-- Navegacao por mes -->
  <div class="mes-navegacao" *ngIf="!usandoPeriodoCustomizado">
    <button pButton
      icon="pi pi-chevron-left"
      class="p-button-text p-button-rounded p-button-sm btn-mes"
      (click)="mesAnterior()">
    </button>
    <span class="mes-label">{{ mesAnoLabel }}</span>
    <button pButton
      icon="pi pi-chevron-right"
      class="p-button-text p-button-rounded p-button-sm btn-mes"
      (click)="proximoMes()">
    </button>
  </div>

  <div class="periodo-customizado-label" *ngIf="usandoPeriodoCustomizado">
    <span>{{ periodoSelecionado.texto }}</span>
    <button pButton
      icon="pi pi-times"
      class="p-button-text p-button-rounded p-button-sm"
      (click)="usandoPeriodoCustomizado = false; recalcularPeriodo(); carregarDados();">
    </button>
  </div>

  <!-- Botao periodo customizado -->
  <app-periodo-filtro
    modo="avancado"
    [valorPadrao]="'showAll'"
    [persistir]="true"
    [textoExibicao]="periodoSelecionado.texto"
    styleClass="btn-periodo-icon"
    (periodoChanged)="onPeriodoChange($event)">
  </app-periodo-filtro>

  <!-- Situacao -->
  <p-dropdown
    [options]="situacaoOptions"
    [(ngModel)]="situacaoSelecionada"
    optionLabel="label"
    optionValue="value"
    (onChange)="onFiltroChange()"
    styleClass="filtro-situacao">
  </p-dropdown>

  <!-- Conta -->
  <p-dropdown
    [options]="contas"
    [(ngModel)]="contaSelecionada"
    [showClear]="true"
    [placeholder]="labels.todas_as_contas"
    [loading]="loadingContas"
    optionLabel="label"
    optionValue="value"
    (onChange)="onFiltroChange()"
    styleClass="filtro-conta">
    <ng-template pTemplate="selectedItem">
      <div class="dropdown-conta-item" *ngIf="contaSelecionada !== null && contaSelecionada !== undefined">
        <img *ngIf="getContaFlagUrl(contaSelecionada)" [src]="getContaFlagUrl(contaSelecionada)" class="flag-icon-small" alt="" />
        <span>{{ getContaLabel(contaSelecionada) }}</span>
      </div>
    </ng-template>
    <ng-template pTemplate="item" let-conta>
      <div class="dropdown-conta-item">
        <img *ngIf="conta.flagUrl" [src]="conta.flagUrl" class="flag-icon-small" alt="" />
        <span>{{ conta.label }}</span>
      </div>
    </ng-template>
  </p-dropdown>

  <!-- Busca por nome de pessoa -->
  <span class="p-input-icon-left filtro-busca-pessoa">
    <i class="pi pi-search"></i>
    <input
      type="text"
      pInputText
      [placeholder]="placeholders.buscar_pessoa"
      [value]="searchNome"
      (input)="onSearchNomeInput($event)"
      [attr.aria-label]="placeholders.buscar_pessoa" />
  </span>
</div>

<!-- Cards Resumo -->
<div class="resumo-section" *ngIf="!loadingTotais && totais">
  <div class="grid">
    <!-- Card Aberto / Cancelado (reaproveita slot quando situacao=CANCELADO) -->
    <div class="col-12" [ngClass]="situacaoSelecionada === 'CANCELADO' ? '' : 'md:col-6'">
      <div class="resumo-card" [ngClass]="tipoSelecionado === 'ENTRADA' ? 'resumo-warning' : 'resumo-danger'">
        <div class="resumo-card-header">
          <i [class]="iconAberto"></i>
          <span>{{ labelAberto }}</span>
        </div>
        <div class="resumo-card-body">
          <div class="resumo-moeda-row" *ngFor="let card of cardsAberto">
            <span class="resumo-moeda-simbolo">{{ card.simbolo }}</span>
            <span class="resumo-moeda-valor">{{ card.valor | number:'1.0-0' }}</span>
          </div>
        </div>
      </div>
    </div>

    <!-- Card Recebido/Pago (oculto quando situacao=CANCELADO) -->
    <div class="col-12 md:col-6" *ngIf="situacaoSelecionada !== 'CANCELADO'">
      <div class="resumo-card resumo-success">
        <div class="resumo-card-header">
          <i [class]="iconRecebido"></i>
          <span>{{ labelRecebido }}</span>
        </div>
        <div class="resumo-card-body">
          <div class="resumo-moeda-row" *ngFor="let card of cardsRecebido">
            <span class="resumo-moeda-simbolo">{{ card.simbolo }}</span>
            <span class="resumo-moeda-valor">{{ card.valor | number:'1.0-0' }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Skeleton dos cards resumo -->
<div class="resumo-section" *ngIf="loadingTotais">
  <div class="grid">
    <div class="col-12 md:col-6">
      <p-skeleton width="100%" height="120px" borderRadius="16px"></p-skeleton>
    </div>
    <div class="col-12 md:col-6">
      <p-skeleton width="100%" height="120px" borderRadius="16px"></p-skeleton>
    </div>
  </div>
</div>

<!-- Table Card - Lista de Titulos -->
<div class="table-card">
  <div class="card-header">
    <div class="card-header-icon table-icon">
      <i class="pi pi-list"></i>
    </div>
    <span class="card-header-title">{{ labels.nome_pessoa }}</span>
  </div>

  <div class="card-content">
    <!-- Skeleton de loading -->
    <div *ngIf="loading" class="pessoas-skeleton">
      <p-skeleton *ngFor="let i of [1, 2, 3]" width="100%" height="90px" borderRadius="12px" styleClass="mb-3"></p-skeleton>
    </div>

    <!-- Empty State -->
    <div *ngIf="!loading && titulos.length === 0" class="empty-state">
      <i class="pi pi-inbox empty-state-icon"></i>
      <p>{{ mensagens.nenhuma_pessoa }}</p>
    </div>

    <!-- Lista de Cards de Titulos (estilo mobile) -->
    <div *ngIf="!loading && titulos.length > 0" class="titulos-lista">
      <div class="titulo-card" *ngFor="let titulo of titulos"
        [ngClass]="tipoSelecionado === 'SAIDA' ? 'borda-saida' : 'borda-entrada'">

        <!-- Linha principal: info + valor destaque + seta -->
        <div class="titulo-card-main" (click)="abrirPessoa(titulo)">
          <div class="titulo-card-info">
            <div class="titulo-nome">
              <i class="pi pi-file-edit"></i>
              <span>#{{ titulo.codigoTitulo || titulo.id }}</span>
              <span class="titulo-pessoa-nome" *ngIf="titulo.nomePessoa">- {{ titulo.nomePessoa }}</span>
            </div>
            <div class="titulo-detalhes">
              <span class="titulo-vencimento">
                <i class="pi pi-calendar"></i>
                {{ labels.vencimento }}: {{ formatarVencimento(titulo.vencimento) }}
              </span>
              <span class="titulo-valor-original" *ngIf="titulo.valor > 0">
                {{ labels.valor }}: {{ getMoedaSimbolo(titulo.moeda) }} {{ titulo.valor | number:'1.0-0' }}
              </span>
            </div>
            <div class="titulo-badges">
              <span class="titulo-parcela" *ngIf="titulo.numeroParcela">
                Parcela: {{ titulo.numeroParcela }}
              </span>
              <span class="badge-situacao"
                [ngClass]="{
                  'badge-pago': titulo.situacaoDeCobranca === 'PAGO',
                  'badge-aberto': titulo.situacaoDeCobranca === 'ABERTO',
                  'badge-cancelado': titulo.situacaoDeCobranca === 'CANCELADO'
                }">
                {{ titulo.situacaoDeCobranca === 'PAGO'
                    ? labels.pago
                    : (titulo.situacaoDeCobranca === 'CANCELADO' ? labels.cancelado : labels.aberto) }}
              </span>
            </div>
          </div>
          <div class="titulo-card-valor">
            <span class="titulo-valor-destaque"
              [ngClass]="{
                'valor-pago': situacaoSelecionada === 'PAGO',
                'valor-aberto': situacaoSelecionada === 'ABERTO',
                'valor-cancelado': situacaoSelecionada === 'CANCELADO'
              }">
              {{ getMoedaSimbolo(titulo.moeda) }}
              <ng-container [ngSwitch]="situacaoSelecionada">
                <ng-container *ngSwitchCase="'PAGO'">
                  {{ (calcularTotalPago(titulo) > 0 ? calcularTotalPago(titulo) : titulo.valor) | number:'1.0-0' }}
                </ng-container>
                <ng-container *ngSwitchCase="'CANCELADO'">
                  {{ titulo.valor | number:'1.0-0' }}
                </ng-container>
                <ng-container *ngSwitchDefault>
                  {{ titulo.saldo | number:'1.0-0' }}
                </ng-container>
              </ng-container>
            </span>
          </div>
          <div class="titulo-card-arrow">
            <i class="pi pi-chevron-right"></i>
          </div>
        </div>

        <!-- Pagamentos parciais expandiveis -->
        <div class="titulo-pagamentos" *ngIf="temPagamentos(titulo)">
          <button pButton type="button"
            class="p-button-text p-button-sm btn-toggle-pagamentos"
            [icon]="expandedRows[titulo.id] ? 'pi pi-chevron-up' : 'pi pi-chevron-down'"
            [label]="labels.pagamentos_titulo"
            (click)="toggleExpand(titulo)">
          </button>
          <div *ngIf="expandedRows[titulo.id]" class="pagamentos-list">
            <div class="pagamento-item" *ngFor="let pag of titulo.tipoDeCobranca">
              <div class="pagamento-info">
                <i class="pi pi-calendar"></i>
                <span>{{ formatarVencimento(pag.emissaoMovimento || '') }}</span>
                <span class="badge-antecipado"
                  *ngIf="pag.emissaoMovimento && titulo.vencimento && pag.emissaoMovimento < titulo.vencimento">
                  Antecipado
                </span>
              </div>
              <div class="pagamento-valor">
                {{ getMoedaSimbolo(titulo.moeda) }} {{ (pag.valorMovimento || pag.valor) | number:'1.0-0' }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Paginacao -->
    <p-paginator
      *ngIf="totalRecords > 0"
      [rows]="rows"
      [totalRecords]="totalRecords"
      [first]="first"
      [rowsPerPageOptions]="[10, 20, 50]"
      (onPageChange)="onPageChange($event)">
    </p-paginator>
  </div>
</div>
